import { Ref } from "react";
import { useDropzone } from "react-dropzone";
import { dropzoneViewTyoe } from "../types";
const DropZone = ({
  uploadElement,
  service,
  content,
  error,
  acceptImageTypes,
  onDrop,
  analytics,
  image
}: dropzoneViewTyoe): JSX.Element => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptImageTypes,
    multiple: false,
  });

  return (
    <div className="service__dropzone" {...getRootProps({})} style={{display: image ? 'none' : 'block'}}>
      <div className="service__dropzone-content">
        <label>
          <input className="dropzone-input" {...getInputProps()} />
        </label>
        {isDragActive ? (
          <>
            <i className="icon__dropzone" />
            <span>{content.dragAndDropRelease}</span>
          </>
        ) : (
          <>
            <i className={error ? "icon__dropzone_error" : "icon__dropzone"} />

            <span
              className={error && "validation-error"}
              dangerouslySetInnerHTML={{
                __html: error ? content[error] : content.dragAndDrop,
              }}
            ></span>
            <button
              className="service__dropzone-btn btn btn__primary"
              onClick={() => {
                analytics.sendUploadBtnClick("dropzone-main");
              }}
            >
              {content.uploadBtn}
            </button>

            <button ref={uploadElement} style={{ display: "none" }}></button>
          </>
        )}
      </div>
    </div>
  );
};

export default DropZone;
